import Dialog from "./dialog";
import Edrone from './edrone';
import LocalCart from './local-cart';

function formatValues(title, values, after) {
    let html = '';
    html += `<div class="values table-values">`
        + `<div class="values-title">${title}</div>`
        + `<div class="values-rows">`;
    values.forEach(function (val) {
        let t = val.title.replace('-', "<div class='tab'></div>");
        html += `<div class="values-row">`
            + `<div class="values-title">${t}</div>`
            + `<div class="values-val">${val.value}</div>`
            + `</div>`;
    });
    html += `</div>`;//.rows
    html += after ? '<div class="after">' + after + '</div>' : '';
    html += `</div>`;//.table-values
    return html;
}

$(document.body).on("update_html_fragments", function (_event, fragments) {
    if (!fragments) {
        return;
    }
    $.each(fragments, function (selector, html) {
        $(selector).replaceWith(html);
    });
});

$(document).on('ready', function () {
    $("body").on('click', '.open-juice-popup', function (ev) {

        var self = $(ev.currentTarget);

        if (typeof self.data('product_cat') == 'undefined') {
            self = self.closest('.juice_packs_content').find("[data-product_cat]");
        }
        Edrone.push(function (_edrone) {
            _edrone.action_type = 'product_view';
            _edrone.product_images = self.data('product_img');
            _edrone.product_category_names = self.data('product_cat');
            _edrone.product_titles = self.data('product_title');
            _edrone.product_ids = self.data('product-id') || self.data('diet_id');
            _edrone.product_urls = window.location.href;
            _edrone.init();
        });


        let pid = ev.currentTarget.getAttribute('data-product-id');

        $.post(
            backend.ajax,
            { action: 'ncp_open_juice_popup', product_id: pid },
            function (data) {
                if (data && data.fragments) {
                    $(document.body).trigger("update_html_fragments", [data.fragments]);
                }
            }
        );

        let j = window.juice_popups['product_' + pid];
        let html = '';
        let srcset = '';
        if (j.big_image.srcset && j.big_image.srcset.length) {
            srcset = `srcset="${j.big_image.srcset}"`;
        }
        html +=
            `<div class="juice-popup-content" ${j.is_upsell ? 'data-cart_type="upsell"' : ''}>`
            + `<div class="product-top">`
            + `<div class="product-info">`
            + `<h2 class="title">${j.title}</h2>`
            + `<div class="ingredients">${j.ingredients}</div>`
            + `<div class="omnibus">${j.omnibus}</div>`
            + `<div class="desc">${j.description}</div>`
            + `</div>`//.product-info
            + `<div class="product-img-wrap">`
            + `<img class="product-img" src="${j.big_image.src}" ${srcset} alt="">`
            + `</div>`//.product-img
            + `</div>`//.product-top

        if(j.values.length || j.vitamins.length) {
            html += `<div class="product-values">`;
            if(j.values.length) {
                html += formatValues('Wartości odżywcze w 100ml', j.values);
            }
            if(j.vitamins.length) {
                html += formatValues('Witaminy *', j.vitamins, '* Wartości Wskazanego Dziennego Spożycia (GDA) dla osoby dorosłej na poziomie 2000 kcal.');
            }
            html += `</div>`;//.product-values
        }
        if (j.is_upsell) {
            html += `<a href="#"
                        class="ghost_button bg_red ladda-button add-upsell-to-cart"
                        data-product-id="${j.id}"
                        data-product-name="${j.title}"
                        id="" data-style="expand-right">
                        <span class="ladda-label">Dodaj +${j.price}</span>
                        <span class="ladda-spinner"></span>
                    </a>`
        }
        html += `</div>`;//.juice-popup-content
        let dlg = new Dialog(html);
        setTimeout(function () {

            LocalCart.create(dlg.get$El().find('.juice-popup-content'));
        });
    });
});



// WEBPACK FOOTER //
// ./assets/js/juice-popup.js